/** Paths each role is blocked from (prefix match). SuperAdmin/Admin = full access. */
export const ROLE_BLOCKED: Record<string, string[]> = {
    Radiologist: ['/pathology', '/lab', '/team'],
    Pathologist: ['/radiology', '/team'],
};

/** Returns true if the given pathname is blocked for the role. */
export function isPathBlocked(pathname: string, role: string | null | undefined): boolean {
    if (!role) return false;
    const blocked = ROLE_BLOCKED[role] ?? [];
    return blocked.some(
        prefix => pathname === prefix || pathname.startsWith(prefix + '/')
    );
}

/** Filters a flat/nested menu-item list, removing items blocked for the role. */
export function filterSidebarItems<T extends { path?: string }>(
    items: T[],
    role: string | null | undefined
): T[] {
    if (!role) return items;
    const blocked = ROLE_BLOCKED[role] ?? [];
    if (!blocked.length) return items;
    return items.filter(
        item => !item.path || !blocked.some(
            prefix => item.path === prefix || item.path!.startsWith(prefix + '/')
        )
    );
}
